<template>
  <div>
    <homelogo />
    <v-img src="@/assets/ComputadoresViajeros/imagen_cabezote.jpg"></v-img>
    <v-row>
      <v-col lg="4" md="12" sm="12" cols="12">
        <h1 class="text-center titles px-10">ESTA INICIATIVA</h1>
      </v-col>
      <v-col lg="8" md="12" sm="12" cols="12">
        <p class="parrafos1 px-10 text-center">
          Es un programa socio-ambiental que emplea Residuos de Aparatos
          Eléctricos y Electrónicos –RAEE- en prácticas de Reacondicionamiento.
          La tecnología obsoleta o dada de baja por empresas, universidades, hogares, 
          entre otros, se transforma en recursos útiles que son destinados
          a instituciones que desarrollen algún tipo de labor social, educativa o de
          salud con niños y niñas entre los 0 y 9 años de edad.
        </p>
      </v-col>
    </v-row>
    <v-img src="@/assets/ComputadoresViajeros/imagen_parrafo_dos.jpg"></v-img>
    <v-row>
      <v-col lg="4" md="12" sm="12" cols="12">
        <h1 class="text-center titles px-10">A quien beneficia</h1>
      </v-col>
      <v-col lg="8" md="12" sm="12" cols="12">
        <p class="parrafos1 px-10 text-center">
          Este programa apoya a jardines infantiles, escuelas, colegios, bibliotecas, fundaciones,
          hospitales, o quienes desarrollen algún tipo de labor social o educativa con niños entre
          los 0 y 9 años de edad, y que demuestren la falta de equipos de cómputo dentro de sus
          labores diarias.
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col lg="6" md="12" sm="12" cols="12">
        <div class="bckCloud text-center">
        
        <!-- <v-img max-width="20%" src="@/assets/ComputadoresViajeros/nube_uno.png"></v-img> -->
        <h1 class="titles text-center px-10">Objetivo</h1>
        <p class="parrafos1 text-center px-10">
          Disminuir la brecha digital de nuestro país dotando de
          equipos de cómputo reacondicionados a instituciones del
          sector educativo, social o de salud que trabajan con niños
          entre los 0 y 9 años de edad.
        </p>
        </div>
      </v-col>
      <v-col lg="6" md="12" sm="12" cols="12">
        <v-img src="@/assets/ComputadoresViajeros/imagen_parrafo_tres.jpg"></v-img>
      </v-col>
    </v-row>
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="12" lg="6" md="8" sm="12">
        <h1 class="titles text-center px-12">Cómo Participar</h1>
        <p class="parrafos1 text-center px-12">
          Para participar en este programa es importante demostrar la falta de equipos
          de cómputo dentro de las labores cotidianas de las instituciones que trabajan
          con primera infancia. Queremos conocer tu necesidad, diligencia el formulario
          a continuación para que establezcamos comunicación.
        </p>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-row>
      <v-col lg="6" md="6" sm="12" cols="12">
        <h1 class="titles text-center px-12">Datos Solicitante</h1>
        <div class="bckForm text-center">
          <form @submit.prevent="sendEmail">
            <v-col cols="12">
              <v-text-field
                label="Nombre"
                name="user_name"
                filled
                outlined
                rounded
                solo
                v-model="nombre1"
                color="orange"
                class="borderorange"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Cargo"
                name="cargo"
                filled
                outlined
                rounded
                solo
                v-model="cargo1"
                color="orange"
                class="borderorange"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Correo Electronico"
                name="correo"
                filled
                outlined
                rounded
                solo
                v-model="correo1"
                color="orange"
                class="borderorange"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Teléfono / Celular"
                name="telefono"
                filled
                outlined
                rounded
                solo
                v-model="tel1"
                color="orange"
                class="borderorange"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Ciudad"
                name="ciudad"
                filled
                outlined
                rounded
                solo
                v-model="ciudad1"
                color="orange"
                class="borderorange"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                label="Comentarios"
                name="comentarios"
                filled
                outlined
                rounded
                solo
                v-model="comentarios1"
                color="orange"
                class="borderorange"
                height="350"
                hide-details
              ></v-textarea>
            </v-col>
            <v-btn
              width="100%"
              height="55"
              rounded
              color="orange"
              class="mx-auto white--text"
              type="submit"
            >
              <h2>Enviar</h2>
            </v-btn>
            <tooltipbtn/>
            
            <!-- <v-btn @click="clear">clear</v-btn> -->
          </form>
        </div>
      </v-col>
      <v-col lg="6" md="6" sm="12" cols="12">
        <h1 class="titles text-center px-12">Datos Institución</h1>
        <div class="bckForm text-center">
          <form @submit.prevent="sendEmail">
            <v-col cols="12">
              <v-text-field
                label="Nombre de la persona responsable de la institución"
                name="user_name"
                filled
                outlined
                rounded
                solo
                v-model="nombre2"
                color="orange"
                class="borderorange"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Nombre de la institución"
                name="institucion2"
                filled
                outlined
                rounded
                solo
                v-model="institucion2"
                color="orange"
                class="borderorange"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Correo Electronico"
                name="correo"
                filled
                outlined
                rounded
                solo
                v-model="correo2"
                color="orange"
                class="borderorange"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Teléfono / Celular"
                name="telefono"
                filled
                outlined
                rounded
                solo
                v-model="tel2"
                color="orange"
                class="borderorange"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Ciudad"
                name="ciudad"
                filled
                outlined
                rounded
                solo
                v-model="ciudad2"
                color="orange"
                class="borderorange"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Dirección"
                name="direccion"
                filled
                outlined
                rounded
                solo
                v-model="direccion2"
                color="orange"
                class="borderorange"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                label="Comentarios"
                name="comentarios"
                filled
                outlined
                rounded
                solo
                v-model="comentarios1"
                color="orange"
                class="borderorange"
                height="250"
                hide-details
              ></v-textarea>
            </v-col>
            <v-btn
              width="100%"
              height="55"
              rounded
              color="orange"
              class="mx-auto white--text"
              type="submit"
            >
              <h2>Enviar</h2>
            </v-btn>
            <tooltipbtn/>
            <!-- <v-btn @click="clear">clear</v-btn> -->
          </form>
        </div>
      </v-col>
    </v-row>
    <h1 class="titles text-center px-12">Algunas de las instituciones beneficiadas</h1>
    <v-row align-center justify-center class="pa-6 ma-6">
      <v-col lg="6" md="12" sm="12" cols="12">
        <v-layout align-center justify-center>
          <v-img
            position="bottom"
            justify-center
            src="@/assets/ComputadoresViajeros/cuadro_fundaciones.png"
          >
            <h2 class="parrafos2">
              Fundación de Atención a la Ninez
              FAN
              <br />Medellín - Colombia
            </h2>
          </v-img>
        </v-layout>
      </v-col>
      <v-col lg="6" md="12" sm="12" cols="12">
        <v-layout align-center justify-center>
          <v-img src="@/assets/ComputadoresViajeros/cuadro_fundaciones.png">
            <h2 class="parrafos2">
              Pro-Marginados
              <br />Medellín - Colombia
            </h2>
          </v-img>
        </v-layout>
      </v-col>
      <v-col lg="6" md="12" sm="12" cols="12">
        <v-layout align-center justify-center>
          <v-img src="@/assets/ComputadoresViajeros/cuadro_fundaciones.png">
            <h2 class="parrafos2">
              Jardín Mis Piedras Preciosas
              <br />Soacha - Colombia
            </h2>
          </v-img>
        </v-layout>
      </v-col>
      <v-col lg="6" md="12" sm="12" cols="12">
        <v-layout align-center justify-center>
          <v-img src="@/assets/ComputadoresViajeros/cuadro_fundaciones.png">
            <h2 class="parrafos2">
              Funsonrisa
              <br />Nariño - Colombia
            </h2>
          </v-img>
        </v-layout>
      </v-col>
      <v-col lg="6" md="12" sm="12" cols="12">
        <v-layout align-center justify-center>
          <v-img src="@/assets/ComputadoresViajeros/cuadro_fundaciones.png">
            <h2 class="parrafos2">
              Escuela Quebrada del Campo
              <br />Cajicá - Colombia
            </h2>
          </v-img>
        </v-layout>
      </v-col>
      <v-col lg="6" md="12" sm="12" cols="12">
        <v-layout align-center justify-center>
          <v-img src="@/assets/ComputadoresViajeros/cuadro_fundaciones.png">
            <h2 class="parrafos2">
              IED Capellaníaa
              <br />Cajicá - Colombia
            </h2>
          </v-img>
        </v-layout>
      </v-col>
      <v-col lg="6" md="12" sm="12" cols="12">
        <v-layout align-center justify-center>
          <v-img src="@/assets/ComputadoresViajeros/cuadro_fundaciones.png">
            <h2 class="parrafos2">
              Gimnasio Nueva Andalucía
              <br />Bosa - Colombia
            </h2>
          </v-img>
        </v-layout>
      </v-col>
    </v-row>
    <h1 class="titles text-center px-12">Galeria</h1>
    <v-row align-center justify-center class="pa-12 ma-12">
      <v-col lg="6" md="12" sm="12" cols="12">
        <v-layout align-center justify-center>
          <v-img src="@/assets/ComputadoresViajeros/1.jpg"></v-img>
        </v-layout>
      </v-col>
      <v-col lg="6" md="12" sm="12" cols="12">
        <v-layout align-center justify-center>
          <v-img src="@/assets/ComputadoresViajeros/2.jpg"></v-img>
        </v-layout>
      </v-col>
      <v-col lg="6" md="12" sm="12" cols="12">
        <v-layout align-center justify-center>
          <v-img src="@/assets/ComputadoresViajeros/3.jpg"></v-img>
        </v-layout>
      </v-col>
      <v-col lg="6" md="12" sm="12" cols="12">
        <v-layout align-center justify-center>
          <v-img src="@/assets/ComputadoresViajeros/4.jpg"></v-img>
        </v-layout>
      </v-col>
      <v-col lg="6" md="12" sm="12" cols="12">
        <v-layout align-center justify-center>
          <v-img src="@/assets/ComputadoresViajeros/5.jpg"></v-img>
        </v-layout>
      </v-col>
      <v-col lg="6" md="12" sm="12" cols="12">
        <v-layout align-center justify-center>
          <v-img src="@/assets/ComputadoresViajeros/6.jpg"></v-img>
        </v-layout>
      </v-col>
      <v-col lg="6" md="12" sm="12" cols="12">
        <v-layout align-center justify-center>
          <v-img src="@/assets/ComputadoresViajeros/7.jpg"></v-img>
        </v-layout>
      </v-col>
      <v-col lg="6" md="12" sm="12" cols="12">
        <v-layout align-center justify-center>
          <v-img src="@/assets/ComputadoresViajeros/8.jpg"></v-img>
        </v-layout>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import homelogo from "@/components/homelogo/homelogo.vue";
import emailjs from "emailjs-com";
import tooltipbtn from '@/components/tooltip.vue'
export default {
  data: () => ({
    nombre1: null,
    cargo1: null,
    correo1: null,
    tel1: null,
    ciudad1: null,
    comentarios1: null,
    nombre2: null,
    institucion2: null,
    correo2: null,
    tel2: null,
    ciudad2: null,
    direccion2: null
  }),
  components: {
    homelogo,
    tooltipbtn
  },
  method: {
    recaptcha() {
      return this.$recaptcha('login').then((token) => {
        console.log(token) // Will print the token
      })
      // .catch((e)=>{
        // clave site
        // 6LesXK4ZAAAAAN8wzzIXMTTjjt0-iZhnROb90Y0A
        //clave secreta
        // 6LesXK4ZAAAAAHd0bbwiX72KFfkdXkwgJiHOfpZY
        // console.log(e)
      // })
    },
    sendEmail(e) {
      console.log(e);
      this.recaptcha().then(()=>{
      emailjs
        .sendForm(
          "gmail",
          "template_gj3VK0oQ",
          e.target,
          "Ef4pW9SP33f_8T-Rv"
        )
        .then(
          result => {
            this.color = "green";
            this.text = "Su correo ha sido enviado";
            this.snackbar = true;
            (this.nombreContacto = null),
              (this.correoContacto = null),
              (this.telefonoContacto = null),
              (this.comentariosContacto = null);
            console.log("SUCCESS!", result.status, result.text);
          },
          error => {
            this.text =
              "Se ha generado un error por favor comuníquese con el administrador";
            this.color = "red";
            console.log("FAILED...", error);
            this.snackbar = true;
          }
        );
    
    
    }).catch((e)=>{
         this.text =
              "Se ha generado un error por favor comuníquese con el administrador";
            this.color = "red";
            this.snackbar = true;
            console.log("FAILED...", e);
      })
      }
  }
};
</script>
<style scoped>
/* @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@900&display=swap'); */
.imglogo {
  position: absolute;
  width: 35%;
  z-index: 99;
}
.floatcenter {
  display: flex;
  display: -webkit-flex;
  margin: auto;
}
.bckForm {
  padding-left: 20%;
  padding-right: 20%;
  padding-top: 22%;
  padding-bottom: 20%;
  background-image: url("../assets/ComputadoresViajeros/fomulario.png");
  background-size: 100% 100%;
}
.bckCloud {
  padding-left: 20%;
  padding-right: 20%;
  padding-top: 22%;
  padding-bottom: 20%;
  background-image: url("../assets/ComputadoresViajeros/nubes.png");
  background-size: 100% 100%;
}
</style>